import {createContext} from 'react'

import type {MarginContext} from './types'

export const Context = createContext<MarginContext | null>(null)
